import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
selector: 'formly-wrapper-panel',
template: `
 <div class="sm:grid sm:grid-cols-3 sm:gap-4 items-center sm:pt-5">
    <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> {{to.label}} </label>
    <div class="mt-1 sm:mt-0 sm:col-span-2">
      <ng-container #fieldComponent></ng-container>
    </div>
  </div>
`,
})
export class InputWrapperComponent extends FieldWrapper {
}
